import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  FormLabel,
  Input,
  Spinner,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import UsersList from './UserList';
import userUsersList, { UsersListDrawerProps } from './userUsersList';

const UsersListDrawer: React.FC<UsersListDrawerProps> = (props) => {
  const { i18n, t } = useTranslation();
  const searchUserRef = useRef<HTMLInputElement>(null);
  const dir = i18n.dir();

  const { state, setFilterText, startLoginUser } = userUsersList(props);

  // #region views
  const spinnerView = (
    <Flex justifyContent={'center'} alignItems={'center'} h="100%">
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="blue.500"
        size="xl"
      />
    </Flex>
  );

  const noUserFoundView = (
    <Flex justifyContent={'center'} alignItems={'center'} h="100%">
      <Text>No User Found</Text>
    </Flex>
  );

  const filteredUsers = state.users.filter(
    (user) =>
      user.fullname.toLowerCase().includes(state.filterText.toLowerCase())
    // user.id !== props.activeUserId
  );
  const usersListView =
    state.users.length > 0 ? (
      <UsersList
        users={filteredUsers}
        activeUserId={props.activeUserId}
        startLoginUser={startLoginUser}
        activeUserMessage={t('information.current-user')}
      />
    ) : (
      noUserFoundView
    );

  const headerView = (
    <DrawerBody>
      <Stack spacing="24px">
        <Box>
          <FormLabel htmlFor="username">{t('users.search')}</FormLabel>
          <Input
            ref={searchUserRef}
            id="username"
            value={state.filterText}
            onChange={setFilterText}
            // placeholder={placeholder}
          />
        </Box>
        {state.loading ? spinnerView : usersListView}
      </Stack>
    </DrawerBody>
  );

  // #endregion views

  return (
    <Drawer
      placement={dir === 'ltr' ? 'right' : 'left'}
      onClose={props.onClose}
      isOpen={props.isOpen}
      initialFocusRef={searchUserRef}
      size={'sm'}
    >
      <DrawerOverlay />

      <DrawerContent mr="10px" borderRadius="15px" mt="10px" mb="10px">
        <DrawerHeader borderBottomWidth="1px">
          <Text>{t('users.all')}</Text>
          <DrawerCloseButton />
        </DrawerHeader>
        {headerView}
      </DrawerContent>
    </Drawer>
  );
};

export default UsersListDrawer;
